/**
 * Created by xiaomo on 2021/12/2.
 */
export const ORDERAPI = {
    orderPage:'/cms/order/page',
    examReportPage:'/cms/exam/report/page',
    examReportDetailOriginal:'/cms/exam/report/detail/original',
    examReportDetailData:'/cms/exam/report/detail/data',
    examReportDetailList:'/cms/exam/report/list', // 用户档案详情体检报告列表
    orderExport:'/cms/order/export',
    providerPage:'/cms/provider/page',
    examReportDetailOcr: '/cms/exam/report/detail/ocr',
    orderLogList: '/cms/order/log/list', // 核保体检-订单轨迹列表
    orderLogCancelCount: '/cms/order/log/cancel/count', // 核保体检-订单预约取消次数
    orderOptions: '/cms/order/option', // 订单的筛选项数据
    orderReportDownload: '/cms/exam/report/detail/download', // 订单报告下载
    examReportImport: "/cms/report/import/create", // 体检报告导入
    examReportList: "/cms/report/import/list", // 体检报告导入列表信息
    examReportException: "/cms/exam/report/exceptionItem", // 体检报告异常数据
    userDocOrderList: "/cms/user/order", // 用户档案服务记录
    orderItemList: "/cms/order/item/list", // 服务项目列表
    orderProviderList: "/cms/order/provider/list", // 供应商列表
    reportSourceList: "/cms/exam/report/source/list", // 报告来源list
}